/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

/**
 * Status values for test suggestions from member backend
 */
export type TestSuggestionStatus = typeof TestSuggestionStatus[keyof typeof TestSuggestionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestSuggestionStatus = {
  surfaced: 'surfaced',
  completed: 'completed',
  deleted: 'deleted',
} as const;
